import { Injectable } from '@angular/core';

/** Service que valida os acessos e execuções de funcionalidades das áreas */
@Injectable({
    providedIn: 'root'
})
export class AreaAuthGuardService {

    /** Verifica se pode editar uma área */
    canEdit(): boolean {
        return true;
    }

    /** Verifica se pode excluir uma área */
    canDelete(): boolean {
        return true;
    }
}
